module.exports = __webpack_public_path__ + "img/09.ab3e1d6c.png";